module.exports = __webpack_public_path__ + "media/images/arrow-input-blue-88ce2d7980265e45474cde1a5a9e8d96.png";